export default __webpack_public_path__ + "static/media/ftj-7.b635d19a.jpeg";